import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12 mb-20" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_14 = { class: "text-nowrap" }
const _hoisted_15 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { class: "row mt-40" }
const _hoisted_22 = { class: "col-md-6 mb-2" }
const _hoisted_23 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_24 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "col-md-6 mb-2" }
const _hoisted_28 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_29 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_center = _resolveComponent("center")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Image du produit ", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: 
                _ctx.product.pic
                  ? _ctx.product.pic
                  : require('@/assets/images/NoImage.png')
              ,
                class: "rounded-circle me-15",
                style: {"width":"90px","height":"90px","object-fit":"cover"}
              }, null, 8, _hoisted_6)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom du produit", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none rounded-0 text-black",
                placeholder: "e.g. Sensung Smart Watch",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.product.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.product.name]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Description Produit ", -1)),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.product.desc) = $event)),
                  placeholder: "Write your product description",
                  class: "form-control shadow-none rounded-0 text-black"
                }, null, 512), [
                  [_vModelText, _ctx.product.desc]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editProduct && _ctx.editProduct(...args)))
            }, " Enregistrer ")
          ])
        ])
      ])
    ]),
    _createVNode(_component_vue_good_table, {
      columns: _ctx.columns,
      rows: _ctx.product.variantsList
    }, {
      "table-row": _withCtx((props) => [
        (props.column.field === 'inventory_ref')
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(props.row.inventory_ref), 1)
            ]))
          : (props.column.field === 'stores')
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                (
            props.row.inventories_stores &&
            props.row.inventories_stores.length != 0
          )
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.row.inventories_stores, (str, indx) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "text-nowrap",
                        key: indx
                      }, [
                        _createTextVNode(_toDisplayString(str.magasin.name) + " ", 1),
                        _createElementVNode("small", null, " (" + _toDisplayString(str.magasin.market) + ")", 1)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]))
            : (props.column.field === 'qty_not_received')
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "-500000",
                      max: "500000",
                      class: "form-control",
                      "onUpdate:modelValue": ($event: any) => ((props.row.qty_not_received) = $event)
                    }, null, 8, _hoisted_18), [
                      [_vModelText, props.row.qty_not_received]
                    ]),
                    _createElementVNode("button", {
                      style: {"margin-left":"1%"},
                      class: "btn btn-info",
                      onClick: ($event: any) => (_ctx.editQnty(props.row))
                    }, _cache[6] || (_cache[6] = [
                      _createElementVNode("i", { class: "ph ph-floppy-disk" }, null, -1)
                    ]), 8, _hoisted_19)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(props.formattedRow[props.column.field]), 1))
      ]),
      _: 1
    }, 8, ["columns", "rows"]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", null, "Historique")
          ], -1)),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columnsHist,
              rows: _ctx.histories
            }, {
              emptystate: _withCtx(() => [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("Aucune entrées correspondants trouvés", -1)
                  ])),
                  _: 1,
                  __: [7]
                })
              ]),
              "table-row": _withCtx((props) => [
                (props.column.field === 'history_type')
                  ? (_openBlock(), _createElementBlock("b", _hoisted_25, _toDisplayString(props.row.text), 1))
                  : (props.column.field === 'created_at')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getDate(props.row.created_at)), 1),
                        _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1))
                      ], 64))
                    : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", null, "Colis avec ce produit")
          ], -1)),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columnsColis,
              rows: _ctx.colis
            }, {
              emptystate: _withCtx(() => [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode("Aucune entrées correspondants trouvés", -1)
                  ])),
                  _: 1,
                  __: [10]
                })
              ]),
              "table-row": _withCtx((props) => [
                (props.column.field === 'parcel_code')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", null, _toDisplayString(props.row.parcel_code), 1),
                      _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1))
                    ], 64))
                  : (props.column.field === 'created_at')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows"])
          ])
        ])
      ])
    ])
  ], 64))
}